import {
  validateNumber,
  validatePresence,
  validateFormat,
} from 'ember-changeset-validations/validators';
import { validateUniqueness } from 'uplisting-frontend/validators/unique';
import { validateValidityPeriods } from 'uplisting-frontend/validators/validity-periods';
import { customMessageValidator } from 'uplisting-frontend/validators/custom-message';

export const PromotionValidation = {
  name: customMessageValidator(
    'promotion_name',
    validatePresence({
      presence: true,
      ignoreBlank: true,
    }),
  ),

  code: [
    customMessageValidator(
      'promotion_code',
      validateFormat({
        presence: true,
        regex: /^[a-z0-9-]+$/i,
        ignoreBlank: true,
      }),
    ),
    customMessageValidator('unique_promotion_code', validateUniqueness()),
  ],

  flatAmount: validateNumber({ gte: 0, allowBlank: false }),

  percentageAmount: validateNumber({ gte: 0, lte: 100, allowBlank: false }),

  validityPeriods: customMessageValidator(
    'promotion_validity_periods',
    validateValidityPeriods(),
  ),
};
